import { UserRole } from '../enums/userRoles';

export enum OrgStatus {
  NEW = 'new',
  ACTIVE = 'active',
  INVALID = 'invalid',
  UNKNOWN = 'unknown',
  EXPIRED = 'expired',
  DELETED = 'deleted',
}

export interface Organization {
  id: string;
  name: string;
  display_name: string;
  logo_url: string | null;
  role: UserRole;
}

export interface OrgCredential {
  id: string;
  active: boolean;
  status: OrgStatus;
  api_key_id?: string;
  organization_id: string;
  user_id: string;
  cirra_user_id: string;
  cirra_organization_id?: string;
  cirra_organization_name?: string;
  is_shared?: boolean;
  source_id?: string;
  username: string;
  hostname: string;
  environment_type: string;
  instance_url: string;
  main_selected_at?: string;
  mcp_selected_at?: string;
  selected_at?: string;
}

export interface AuthParams {
  client_id: string;
  redirect_uri: string;
  code_challenge: string;
  response_type: string;
  state: string;
}
